import clsx from 'clsx';
import React, {ReactChild, ElementType} from 'react';
import {useCookie} from '../../hooks/useCookie';
import defaultTheme from './cookie-bar.module.pcss';

export type Props = {
  label: string;
  heading?: string;
  message?: string;
  children?: ReactChild;
  className?: string;
  /**
   * Name of cookie to check/set
   * @default 'cookies-accepted'
   */
  cookieName?: string;
  /**
   * Element node
   * @default 'div'
   */
  as?: ElementType;
  /**
   * Days until cookie expiration
   * @default 30
   */
  lifetime?: number | string;
  /**
   * ms before visible class is added
   * @default 2000
   */
  delay?: number;
  theme?: {
    root?: string;
    heading?: string;
    message?: string;
    button?: string;
    visible?: string;
    required?: string;
  };
};

export const CookieBar = ({
  as: ComponentProp = 'div',
  lifetime = 30,
  delay = 2000,
  cookieName = 'cookies-accepted',
  children,
  heading,
  message,
  label,
  className,
  theme = defaultTheme,
  ...rest
}: Props) => {
  const {saveCookie, required, visible} = useCookie({
    cookieName,
    delay,
    lifetime,
  });

  const classes = clsx(theme.root, className, {
    [theme.visible as any]: visible,
    [theme.required as any]: required,
  });

  return (
    <ComponentProp className={classes} {...rest}>
      {required && (
        <>
          {heading && <h4 className={theme.heading}>{heading}</h4>}
          {message && <p className={theme.message}>{message}</p>}
          {children}
          <button className={theme.button} onClick={saveCookie}>
            {label}
          </button>
        </>
      )}
    </ComponentProp>
  );
};
